import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Shards } from '#src/atoms/icons/Shards.tsx';
import type { Unit } from '#src/lib/style.ts';
import { getShardColor } from '#src/set/index.ts';

import type { CommonShards_cardSet } from './__generated__/index.graphql.ts';

type Props = {
  cardSet?: Nullable<CommonShards_cardSet>;
  size?: Unit;
  className?: string;
  gradient?: 'purple';
  disableSetColor?: boolean;
};

export const CommonShards = ({
  cardSet,
  size = 2,
  className,
  gradient,
  disableSetColor,
}: Props) => (
  <Shards
    color={
      disableSetColor
        ? undefined
        : getShardColor(Rarity.common, cardSet?.branding)
    }
    size={size}
    className={className}
    gradient={gradient}
  />
);

CommonShards.fragments = {
  cardSet: gql`
    fragment CommonShards_cardSet on CardSet {
      id
      branding {
        id
        colors {
          main
        }
      }
    }
  ` as TypedDocumentNode<CommonShards_cardSet>,
};
